<div class="loading-container" *ngIf="show" [class.overlay]="overlay">
  <div class="loading-content">
    <div class="loader" [class]="'loader-' + size"></div>
    <p class="loading-message" *ngIf="message">{{ message }}</p>
  </div>
</div>
